import { AUTH_REDUCER } from "../constants/enums";
import { toastMessage } from "../helper";
import {
  forgotPasswordOtpService,
  logInService,
  logout,
  registerStoreUserOtpService,
  resetPasswordService,
  sendOtpService,
  signUpService,
  viewProfileService,
  verifyEmployeeAndSetPassword,
  verify2FAAuthOTP,
} from "../services/authService";
import {
  fetchBusinessUnitPreference,
  fetchCompanyAndBusinessUnits,
} from "../services/orgService";
import { externalVerifierOtpVerify } from "../services/verificationService";
import "./types.ts";
export const signUpUser = (
  company: string,
  industry: string,
  email: string,
  password: string,
  code: string,
  accountType: string,
  planId: string,
  planCode: string,
  address: any,
  updatePassword: boolean
) => {
  const signUpReqObj: any = {
    company,
    industry,
    registrationId: code,
    username: email,
    email: email,
    password,
    accountType,
    planId,
    planCode,
    type: "B2B",
    address,
    updatePassword,
  };
  return signUpService(signUpReqObj);
};
export const resendRegisterOTP = (email: string, emailAuth: boolean) => {
  const registerUserNameObject: any = {
    email,
    accountType: localStorage.getItem("accountType"),
  };
  if (emailAuth) {
    registerUserNameObject["emailAuth"] = true;
  }
  return sendOtpService(registerUserNameObject, true);
};

export const registerStoreUserOtpName = (
  email: string,
  otp: string,
  password: string,
  emailURLVerify: Boolean
) => {
  const registerUserNameObject: any = {
    email,
    otp,
  };
  if (emailURLVerify) {
    registerUserNameObject.emailURLVerify = emailURLVerify;
    registerUserNameObject.password = password;
  }
  registerUserNameObject.accountType = localStorage.getItem("accountType");
  return registerStoreUserOtpService(registerUserNameObject);
};
export const verifyEmployee = (
  email: string,
  password: string,
  key?: string | null
) => {
  const userObject: any = {
    email,
    key,
    password,
  };
  return verifyEmployeeAndSetPassword(userObject);
};
export const forgotPasswordGenerateOtp = (email: string) => {
  const registerUserNameObject: any = {
    username: email,
  };
  return forgotPasswordOtpService(registerUserNameObject);
};
export const forgotPasswordVerifyOtp = (email: string, otp: string) => {
  const registerUserNameObject: any = {
    username: email,
    otp,
    otpGenerated: true,
  };
  return forgotPasswordOtpService(registerUserNameObject);
};
export const forgotPasswordResetPassword = (
  email: string,
  password: string,
  newPassword: string
) => {
  const registerUserNameObject: any = {
    username: email,
    otpVerified: true,
    verifyPassword: password,
    newPassword: newPassword,
  };
  return forgotPasswordOtpService(registerUserNameObject);
};
export const resetPassword = (
  email: string,
  currentPassword: string,
  newPassword: string,
  verifyPassword: string
) => {
  const resetPasswordObject: any = {
    username: JSON.parse(localStorage.getItem("user") || "{}")?.username,
    currentPassword,
    newPassword,
    verifyPassword,
  };
  return resetPasswordService(resetPasswordObject);
};
export const verifyOTPAuth = (
  email: string,
  otp: string,
  res: any,
  type: string,
  generateToken: boolean
) => {
  const registerUserNameObject: any = {
    username: email,
    otp,
    role: res.data?.role,
    type,
    generateToken,
  };
  return verify2FAAuthOTP(registerUserNameObject).then(
    async (authVerifyRes: any) => {
      if (!generateToken) {
        return authVerifyRes;
      } else if (authVerifyRes?.data?.token) {
        res.data.token = authVerifyRes.data.token;
        return setFieldsAfterLogin(res);
      }
    }
  );
};
export const signInUser = (
  email: string,
  password: string,
  action: string,
  accountType: string
) => {
  const signInReqObj: any = {
    email: email,
    password: password,
    action: action,
    accountType: accountType,
  };
  return logInService(signInReqObj).then(async (res: any) => {
    if (res) {
      if (
        res.data.redirectToOTP ||
        res.data.emailAuthRequired ||
        res.data.appAuthRequired
      ) {
        return res;
      } else {
        return setFieldsAfterLogin(res);
      }
    }
  });
};

export const setFieldsAfterLogin = async (res: any) => {
  if (res.data.token) {
    const sessionId = JSON.parse(atob(res.data.token?.split(".")[1]))?.iss
      ?.sessionId;
    if (!sessionId?.length) {
      res["emptySessionId"] = true;
      return res;
    }
    logout();
    localStorage.setItem("token", res.data.token);
    localStorage.setItem("user", JSON.stringify(res.data.userProfile));
    localStorage.setItem("bunits", res.data.bunits);
    // localStorage.setItem("username",res.data.userProfile.username);
  }
  let bunitReq: any = {};
  if (res.data.bunits) {
    bunitReq.bunits = res.data.bunits
      .split(",")
      .map((eachUnit: string) => parseInt(eachUnit));
    bunitReq.company = res.data.company;
  }
  if (!res.data.redirectToPending) {
    let compData = await (await fetchCompanyAndBusinessUnits(bunitReq)).data;
    if (!compData) {
      toastMessage("No Company Data Found", "warning");
    }
    if (compData?.businessUnits?.length) {
      localStorage.setItem(
        "businessUnits",
        JSON.stringify(compData.businessUnits)
      );
      localStorage.setItem(
        "currentBusinessUnit",
        JSON.stringify({ id: compData.businessUnits[0].id })
      );
      fetchBusinessUnitPreference(compData.businessUnits[0].id).then(
        (res: any) => {
          localStorage.setItem(
            "categoryPreferences",
            JSON.stringify(res.data.categoryPreferences)
          );
          localStorage.setItem(
            "preference",
            JSON.stringify(res.data.preference)
          );
        }
      );
    }
    localStorage.setItem(
      "companyPreference",
      JSON.stringify(compData.companyPreference)
    );
    localStorage.setItem(
      "protocol",
      JSON.parse(compData.companyPreference.reports).framework[0] == 460
        ? "iso"
        : "ghg"
    );
    localStorage.setItem("company", JSON.stringify(compData.company));
  }
  return res;
};
export const setToken = (token: string | null): any => ({
  type: AUTH_REDUCER.SET_TOKEN,
  payload: token,
});

export const setUserDetails = (data: any): any => ({
  type: AUTH_REDUCER.SET_USER_DATA,
  payload: data,
});
export const setCustomerLogo = (data: any): any => ({
  type: AUTH_REDUCER.SET_CUSTOMER_LOGO,
  payload: data,
});

export const setBunits = (data: any): any => ({
  type: AUTH_REDUCER.SET_BUNITS,
  payload: data,
});
export const setUserName = (userName: string): any => ({
  type: AUTH_REDUCER.SET_USERNAME,
  payload: userName,
});
export const getUserData = () => {
  return viewProfileService();
};

export const setUser = (userData: any): any => ({
  type: AUTH_REDUCER.SET_USER,
  payload: userData,
});
export const logOutUser = () => async (dispatch: any) => {
  try {
    dispatch(logout());
  } catch (e: any) {
    console.log(e);
    // dispatch(authError(e?.data && e?.data?.message));
  }
};

export const externalVerifierLogin = async (
  value: any,
  auditRequestId: any,
  externalVerifierMail: any
) => {
  return externalVerifierOtpVerify({
    auditRequest: auditRequestId,
    otp: value,
    email: externalVerifierMail,
  })
    .then(async (res: any) => {
      if (res?.data?.token) {
        await setFieldsAfterLogin(res);
        localStorage.setItem("from_date", res?.data?.from_date);
        localStorage.setItem("to_date", res?.data?.to_date);
        localStorage.setItem("auditRequestId", res?.data?.id);
        return res;
      }
    })
    .catch((err: any) => {
      toastMessage(err.response.data.message, "error");
      console.log(
        "Error:",
        err.response && err.response.data && err.response.data.message
      );
    });
};
